export const config = {
  apikey: "b7690ca9-43f4-4dbc-80bf-0664cfc1cd01",
  WAAPItakflaterPunktUrl: "//www.webatlas.no/WAAPI-Takflater/takflater/punkt",
  WAAPItakflaterUrl: "//waapi.webatlas.no/wms-takhelning/",
  WAAPIsearchUrl: "//www.webatlas.no/waapi-fritekstsok",
  WAAPIhoydeUrl: "//www.webatlas.no/WAAPI-Hoyde/hoyde",
};
